import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import { FormControl } from 'baseui/form-control'
import getError from '@/containers/SubscriptionFormPage/getError'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'

const ApartmentNumber = () => {
  const { t, updateAddress, errors, apartmentNumber, isApartment, showApartmentNumber, showAddressFields } =
    useAddress()

  if (!showApartmentNumber || !showAddressFields || !isApartment) {
    return null
  }

  return (
    <FormControl error={getError('apartmentNumber', errors)}>
      <SDInput
        label={t('subscriptionForm:address_module.appartment_number')}
        onBlur={apartmentNumber => updateAddress({ apartmentNumber })}
        currentValue={apartmentNumber}
      />
    </FormControl>
  )
}

export default ApartmentNumber
